var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`zhiCustomBtn xt-fab-kf`},[_c('div',{staticClass:"openZhichiCustom",attrs:{"id":"openZhichiCustom"},on:{"click":_vm.openZhichiCustom}},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }